import { createApi } from "@reduxjs/toolkit/query/react";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";

const commonApi = createApi({
    reducerPath: 'commonApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getPDF: builder.query({
            query: (details) => ({
                url: `/Common/getPDF?type=${details.type}&fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        storeBase64Image: builder.mutation({
            query: (details) => ({
                url: '/Common/StoreBase64Image',
                method: 'POST',
                body: details,
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        uploadPDF: builder.mutation({
            query: (details) => ({
                url: '/Common/UploadPDF',
                method: 'POST',
                body: details,
                formData: true
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getExcelSheet: builder.query({
            query: (details) => ({
                url: `/Common/GetExcelSheet?type=${details.type}&fileName=${details.fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getSignUpDropDownsForCorporateMembers: builder.query({
            query: () => ({
                url: encryptQueryString('/Membership/GetSignUpDropDownsForCorporateMembers'),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getAllKeyPositionApprovalRequestList: builder.mutation({
            query: (details) => ({
                url: '/Membership/GetAllKeyPositionApprovalRequestList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getRepresentationDetailForAprrovalById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Membership/GetRepresentationDetailForAprrovalById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAdminDetailList: builder.mutation({
            query: (details) => ({
                url: '/Account/GetAdminDetailList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEditAdminDetails: builder.mutation({
            query: (details) => ({
                url: '/Account/AddEditAdminDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteAdminDetailsById: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Account/DeleteAdminDetailsById`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAdminDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Account/GetAdminDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveChangeKeyPosition: builder.mutation({
            query: (details) => ({
                url: '/Membership/ApproveChangeKeyPositionRequest',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        ChangePasswordForAdmin: builder.mutation({
            query: (details) => ({
                url: '/Account/ChangePasswordForAdmin',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useStoreBase64ImageMutation,
    useUploadPDFMutation,
    useLazyGetPDFQuery,
    useLazyGetExcelSheetQuery,
    useLazyGetSignUpDropDownsForCorporateMembersQuery,
    useGetAllKeyPositionApprovalRequestListMutation,
    useLazyGetRepresentationDetailForAprrovalByIdQuery,
    useGetAdminDetailListMutation,
    useAddEditAdminDetailsMutation,
    useDeleteAdminDetailsByIdMutation,
    useLazyGetAdminDetailByIdQuery,
    useApproveChangeKeyPositionMutation,
    useChangePasswordForAdminMutation
} = commonApi;

export default commonApi;